"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var axiosInit = require("../utils/axios");
var ThrottlerAdapter = require("./adapters/ThrottlerAdapter");
var AXIOS = "axios";
var adapters = (0, _defineProperty2["default"])({}, AXIOS, axiosInit);
var decorateAdapter = function decorateAdapter(adapter, config) {
  var decorated = adapter;
  decorated = new ThrottlerAdapter(adapter, config);
  return decorated;
};
var getAdapterForType = function getAdapterForType(adapterType, config) {
  var buildAdapter = adapters[adapterType];
  if (!buildAdapter) {
    throw new Error("Invalid adapter set, application may not work properly");
  }
  var adapter = buildAdapter(config);
  var decorated = decorateAdapter(adapter, config);
  decorated.__cb_net_adapter_type = adapterType;
  return decorated;
};
var NetworkService = /*#__PURE__*/function () {
  function NetworkService() {
    (0, _classCallCheck2["default"])(this, NetworkService);
    (0, _defineProperty2["default"])(this, "adapter", null);
    (0, _defineProperty2["default"])(this, "services", null);
  }
  return (0, _createClass2["default"])(NetworkService, [{
    key: "setServices",
    value: function setServices(services) {
      this.services = services;
      return this;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      try {
        var _this$services, _this$services$get, _this$services2;
        var adapter = ((_this$services = this.services) === null || _this$services === void 0 || (_this$services = _this$services.config) === null || _this$services === void 0 || (_this$services$get = _this$services.get) === null || _this$services$get === void 0 ? void 0 : _this$services$get.call(_this$services, "network.adapter")) || AXIOS;
        this.adapter = getAdapterForType(adapter, (_this$services2 = this.services) === null || _this$services2 === void 0 ? void 0 : _this$services2.config);
      } catch (err) {
        var _this$services3, _this$services4;
        (_this$services3 = this.services) === null || _this$services3 === void 0 || (_this$services3 = _this$services3.logger) === null || _this$services3 === void 0 || _this$services3.error("An error has occurred while initializing the network adapter, defaulting to axios", err);
        this.adapter = getAdapterForType(AXIOS, (_this$services4 = this.services) === null || _this$services4 === void 0 ? void 0 : _this$services4.config);
      }
      return this;
    }
  }, {
    key: "get",
    value: function get() {
      var _this$adapter;
      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }
      var requestConfig = params[1];
      if (requestConfig && requestConfig.retries && this.adapter.__cb_net_adapter_type == AXIOS) {
        requestConfig["axios-retry"] = {
          retries: requestConfig.retries
        };
        delete requestConfig.retries;
      }
      return (_this$adapter = this.adapter) === null || _this$adapter === void 0 ? void 0 : _this$adapter.get.apply(_this$adapter, params);
    }
  }, {
    key: "post",
    value: function post() {
      var _this$adapter2;
      for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }
      //TODO: get the retries code from the get method in here
      return (_this$adapter2 = this.adapter) === null || _this$adapter2 === void 0 ? void 0 : _this$adapter2.post.apply(_this$adapter2, params);
    }
  }, {
    key: "put",
    value: function put() {
      var _this$adapter3;
      for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }
      return (_this$adapter3 = this.adapter) === null || _this$adapter3 === void 0 ? void 0 : _this$adapter3.put.apply(_this$adapter3, params);
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _this$adapter4;
      for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        params[_key4] = arguments[_key4];
      }
      return (_this$adapter4 = this.adapter) === null || _this$adapter4 === void 0 ? void 0 : _this$adapter4["delete"].apply(_this$adapter4, params);
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!NetworkService.instance) {
        NetworkService.instance = new NetworkService();
      }
      return NetworkService.instance;
    }
  }]);
}();
(0, _defineProperty2["default"])(NetworkService, "instance", void 0);
module.exports = NetworkService;